// External packages
import { z } from 'zod';

// Components
import { FileInputField } from 'components/FileInput';
import { Button } from 'components/Button';
import * as Modal from 'components/Modal';
import { Form } from 'components/Form';

const videosFormSchema = z.object({
  video: z.instanceof(File).refine((file) => file instanceof File, {
    message: 'Unesite video',
  }),
});

type AddVideoModalProps = {
  onSubmit: (data: z.infer<typeof videosFormSchema>) => Promise<void> | void;
  modalTrigger?: React.ReactNode;
  isOpen: boolean;
  onOpenChange: (isOpen: boolean) => void;
  isPending?: boolean;
};

export const AddVideoModal: React.FC<AddVideoModalProps> = ({
  onSubmit,
  modalTrigger,
  isOpen,
  onOpenChange,
  isPending = false,
}) => {
  return (
    <Modal.TriggerRoot isOpen={isOpen} onOpenChange={onOpenChange}>
      {modalTrigger}
      <Modal.Overlay isDismissable>
        <Modal.Root>
          <Modal.Dialog>
            <Modal.Close />
            <h3 className="mb-8 text-2xl text-gray-600">Dodaj video</h3>
            <Form schema={videosFormSchema} onSubmit={onSubmit}>
              <FileInputField
                fileTriggerProps={{
                  acceptedFileTypes: ['video/mp4', 'video/webm', 'video/ogg'],
                }}
                label="Video"
                name="video"
              />
              <Button
                type="submit"
                className="mt-12 w-full"
                size="lg"
                isPending={isPending}
              >
                Dodaj video
              </Button>
            </Form>
          </Modal.Dialog>
        </Modal.Root>
      </Modal.Overlay>
    </Modal.TriggerRoot>
  );
};
